/*
*引用cube-ui的toast组件，进行toast提示和loading
*/
window.toast = null;
export default {
	methods: {
		showToast(txt) {
      if (window.toast !== null) {
        return;
      }
			window.toast = this.$createToast({
        txt: txt,
        type: 'txt',
        time: 0
      });
      window.toast.show();
      setTimeout(() => {
      	window.toast && window.toast.hide();
        window.toast = null;
      }, 3000)
		},
		showLoading() {
			window.toast = this.$createToast({
        time: 0,
        txt: ''
      });
      window.toast.show()
		},
		hideLoading() {
			window.toast && window.toast.hide()
      window.toast = null;
		}
	}
}